import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CmsSidebarComponent } from '../cms-sidebar/cms-sidebar';
import { CmsDevLoginComponent } from '../cms-dev-login/cms-dev-login';
import { CmsDevAuthService } from '../cms-auth/cms-dev-auth.service';
import { CMS_BYPASS_GUARD } from '../cms-auth/cms-auth.tokens';
@Component({
  selector: 'lib-cms-layout',
  standalone: true,
  imports: [RouterOutlet, CmsSidebarComponent, CmsDevLoginComponent],
  templateUrl: './cms-layout.html',
  styleUrl: './cms-layout.scss'
})
export class CmsLayoutComponent {
  private readonly bypassGuard = inject(CMS_BYPASS_GUARD);
  private readonly devAuth = inject(CmsDevAuthService);

  // For local development
  readonly showDevLogin = computed(() =>
    this.bypassGuard && !this.devAuth.token()
  );
}
